module.exports = __webpack_public_path__ + "static/media/goods7.c6069d99.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/goods7.png
// module id = 1236
// module chunks = 0